module.exports = __webpack_public_path__ + "static/media/sample-golfer.d4540fc2.png";